import React, { ReactElement } from 'react';

interface ActionButtonProps {
    text: string;
    onClick?: () => void;
    icon?: ReactElement;
    type: string;
    color?: string;
}
export default function ActionButton({ text, onClick, icon, color, type }: ActionButtonProps) {
    return (
        <>
            {type === 'rounded' && (
                <button
                    className={`nv__button nv__button--${color} nv__button--rounded transition`}
                    onClick={onClick}
                >
                    {text} {icon}
                </button>
            )}

            {type === 'rounded--big' && (
                <button
                    className={`nv__button nv__button--${color} nv__button--rounded--big transition`}
                    onClick={onClick}
                >
                    {text} {icon}
                </button>
            )}

            {type === 'rounded--small' && (
                <button
                    className="nv__button nv__button--rounded--small transition"
                    onClick={onClick}
                >
                    {text} {icon}
                </button>
            )}

            {type === 'rounded clear' && (
                <button
                    className="nv__button nv__button--rounded--clear transition"
                    onClick={onClick}
                >
                    {text} {icon}
                </button>
            )}
        </>
    );
}
